import './css/Review.css'
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import imag1 from '../asset/Images/z2.png'

const reviews = [
  {
    text: "Lin's Bistro offers a remarkable dining experience! The Chinese and Thai dishes were bursting with flavor, and the elegant atmosphere made it unforgettable. The service was impeccable, and the team went above and beyond to ensure a perfect evening. Highly recommend!",
    author: "Margaret - Food Critic",
    rating: 5,
  },
  {
    text: "An amazing experience at Lin's Bistro! The food was a delightful blend of authentic Chinese and Thai flavors. The ambiance was warm and inviting, and the staff was attentive and professional. A fantastic choice for any occasion!",
    author: "John Doe - Food Blogger",
    rating: 5,
  },
  {
    text: "Lin's Bistro exceeded all expectations! The dishes were exquisite, the service was outstanding, and the atmosphere was cozy yet classy. A true gem for anyone craving top-notch Chinese and Thai cuisine.",
    author: "Anna Smith - Restaurant Enthusiast",
    rating: 5,
  },
  
];
export default function HeroSection() {
  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <section className="new-review-section">
      {/* Image Section */}
      <div className="image-section">
        <img
          src={imag1}
          alt="Dish"
        />
      </div>

      {/* Review Section */}
      <div className="reviews-section">
        <Slider {...sliderSettings}>
          {reviews.map((review, index) => (
            <div key={index} className="review-card">
              <p className="quote-icon">“</p>
              <h3 className="review-title">{review.text.split(",")[0]}</h3>
              <p className="review-text">{review.text}</p>
              <p className="review-author">
                {review.author} <span className="stars">{"★".repeat(review.rating)}</span>
              </p>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
